"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const storage_handler_1 = require("@ebay-business-components/favorites-utils/dist/utils/browser/storage-handler");
const tracking_handler_1 = require("@ebay-business-components/favorites-utils/dist/utils/browser/tracking-handler");
const index_1 = require("../../constants/index");
const index_2 = require("../../utils/browser/index");
class AddToListDialogComponent extends Marko.Component {
    constructor() {
        super(...arguments);
        this.state = {
            open: false,
            createListOpen: false,
            groupCards: [],
            promptDialog: {},
            openToast: false,
            toastText: '',
            currentListName: '',
        };
    }
    onCreate(input) {
        const open = (0, get_1.default)(input, 'open', false);
        const itemDetails = (0, get_1.default)(input, 'itemDetails', {});
        this.localizedContent = (0, get_1.default)(input, 'localizedContent', {});
        const promptDialog = this.getViewModelForCreateList(input);
        this.state = {
            open,
            createListOpen: false,
            groupCards: [],
            openToast: false,
            toastText: '',
            promptDialog,
            currentListName: '',
        };
        this.watchDataProvider = (0, get_1.default)(input, 'watchDataProvider', {});
        this.getWatchList(true, input);
        if (open) {
            const itemData = (0, get_1.default)(itemDetails, 'itemData', {});
            const trackingInfo = (0, get_1.default)(input, 'trackingData', {});
            const pageId = (0, get_1.default)(trackingInfo, 'pageId', '');
            const trackingData = {
                eventFamily: 'MYEBAY',
                eventAction: 'CLIENT_PAGE_VIEW',
                pageId: `p${pageId}`,
                flushImmediately: false,
                eventProperty: {
                    imp: 4534336,
                    mi: '163179',
                },
            };
            (0, tracking_handler_1.handleTracking)(trackingData, itemData);
        }
    }
    getViewModelForCreateList(input) {
        const itemDetails = (0, get_1.default)(input, 'itemDetails', {});
        return (0, get_1.default)(input, 'promptDialog', {
            open: false,
            title: this.localizedContent.create_list,
            callToAction: {
                cancel: {
                    label: this.localizedContent.cancel,
                    accessibilityLabel: this.localizedContent.cancel,
                    trackingData: (0, index_2.createTrackingData)(itemDetails, 'p4598044.m170758.l9072', ''),
                },
                confirm: {
                    label: this.localizedContent.create,
                    accessibilityLabel: this.localizedContent.create,
                    trackingData: (0, index_2.createTrackingData)(itemDetails, 'p4598044.m170758.l187557', ''),
                },
            },
            inputField: {
                label: this.localizedContent.list_name,
                placeholder: this.localizedContent.list_name_placeholder,
                maxLength: 40,
                textCounterEnabled: true,
                errorMessages: {
                    required: this.localizedContent.list_name_required_text,
                    maxLength: this.localizedContent.list_name_max_length_text,
                    invalid: '',
                },
            },
        });
    }
    handleOpenPromptDialog() {
        const pageId = (0, get_1.default)(this.input, 'trackingData.pageId', '');
        const itemDetails = (0, get_1.default)(this.input, 'itemDetails', {});
        const itemData = (0, get_1.default)(itemDetails, 'itemData', {});
        this.setState({ createListOpen: true });
        const newListTracking = {
            eventFamily: 'MYEBAY',
            eventAction: 'ACTN',
            actionKind: 'CLICK',
            flushImmediately: false,
            pageId: 'p4534336',
            moduleId: 'm170758',
            linkId: 'l187538',
        };
        (0, tracking_handler_1.handleTracking)(newListTracking, itemData);
        const trackingData = {
            eventFamily: 'MYEBAY',
            eventAction: 'CLIENT_PAGE_VIEW',
            flushImmediately: false,
            pageId: `p${pageId}`,
            moduleId: 'm170758',
            eventProperty: {
                imp: 4598044,
            },
        };
        (0, tracking_handler_1.handleTracking)(trackingData, itemData);
    }
    handleClosePromptDialog() {
        this.setState({ createListOpen: false });
    }
    handleCreateList(event) {
        const { inputValue } = event;
        const listDetails = {
            listName: inputValue,
        };
        this.setState({ currentListName: inputValue });
        this.addToWatchList(listDetails);
    }
    handleAddToWatchList(groupCard) {
        const { id, title, disabled } = groupCard;
        const disabledValue = (0, get_1.default)(disabled, 'value', false);
        if (disabledValue || !id || !title) {
            return;
        }
        const listDetails = {
            listId: id,
        };
        this.setState({ currentListName: title });
        const { itemDetails } = this.input;
        const { itemData } = itemDetails;
        const trackingInfo = {
            eventFamily: 'MYEBAY',
            eventAction: 'ACTN',
            actionKind: 'CLICK',
            flushImmediately: false,
            pageId: 'p4534336',
            moduleId: 'm163179',
            linkId: id === 'WATCH_LIST' ? 'l180878' : 'l170168',
            eventProperty: {
                listid: id,
            },
        };
        (0, tracking_handler_1.handleTracking)(trackingInfo, itemData, 'add');
        this.addToWatchList(listDetails);
    }
    showErrorToast(message) {
        this.setState({
            open: false,
        });
        this.emit('toast', true, message, true);
    }
    updateWatchListState(response, input) {
        var _a;
        if ('status' in response &&
            response.status === 'ERROR' &&
            response.message &&
            response.message.length > 0) {
            const errorMessage = (0, get_1.default)(response, 'message', '');
            return this.showErrorToast(errorMessage);
        }
        const trackingData = input === null || input === void 0 ? void 0 : input.trackingData;
        (0, storage_handler_1.setSessionData)(index_1.SESSION_STORAGE, response, 'update', trackingData);
        const userWatchLists = (0, get_1.default)(response, 'userWatchLists', []);
        const itemData = (_a = input === null || input === void 0 ? void 0 : input.itemDetails) === null || _a === void 0 ? void 0 : _a.itemData;
        const formatGroupCards = (0, index_2.formatWatchListData)(userWatchLists, itemData, this.localizedContent);
        this.setState({
            groupCards: formatGroupCards,
        });
    }
    getWatchList(useCache, input) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            try {
                let watchData = (_a = (0, storage_handler_1.processSessionData)(index_1.SESSION_STORAGE)) === null || _a === void 0 ? void 0 : _a.watchData;
                if (!useCache || !watchData) {
                    if ((_b = this.watchDataProvider) === null || _b === void 0 ? void 0 : _b.getWatchListHandler) {
                        watchData =
                            yield this.watchDataProvider.getWatchListHandler();
                    }
                }
                if (watchData && 'redirectURL' in watchData) {
                    return this.emit('redirect', watchData);
                }
                if (watchData && 'status' in watchData) {
                    this.updateWatchListState(watchData, input);
                }
            }
            catch (error) {
                console.error('Error getting watch list', error);
                this.showErrorToast('Something went wrong. Please try again.');
            }
        });
    }
    addToWatchList(listDetails) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const { itemDetails, addToWatchTrackingData, trackingData, localizedContent, } = this.input;
            const { currentListName } = this.state;
            const { addToWatchHandler } = this.watchDataProvider;
            const trackingInfo = addToWatchTrackingData || trackingData;
            const response = yield addToWatchHandler(itemDetails, listDetails, trackingInfo);
            if (response.status === 'SUCCESS') {
                this.setState({
                    open: false,
                    createListOpen: false,
                });
                const toastText = (_a = localizedContent === null || localizedContent === void 0 ? void 0 : localizedContent.added_to_list) === null || _a === void 0 ? void 0 : _a.replace('[listName]', currentListName);
                this.emit('toast', true, toastText, false);
                const { watchData } = (0, storage_handler_1.processSessionData)(index_1.SESSION_STORAGE) || {};
                const formattedWatchData = (0, index_2.formatSessionData)(watchData, response, currentListName);
                (0, storage_handler_1.setSessionData)(index_1.SESSION_STORAGE, formattedWatchData, 'update', trackingData);
            }
            else {
                const { message } = response;
                const { createListOpen } = this.state;
                if (createListOpen) {
                    const errorMessage = (0, get_1.default)(response, 'message', '');
                    this.setState({
                        promptDialog: Object.assign(Object.assign({}, this.state.promptDialog), { inputField: Object.assign(Object.assign({}, this.state.promptDialog.inputField), { errorMessages: Object.assign(Object.assign({}, this.state.promptDialog.inputField
                                    .errorMessages), { invalid: errorMessage }) }) }),
                    });
                }
                else {
                    this.setState({
                        open: false,
                        createListOpen: false,
                    });
                    this.emit('toast', true, message, false);
                }
            }
        });
    }
}
exports.default = AddToListDialogComponent;
